<template>
  <UButton
    class="!text-white rounded-full !py-3 !px-8 !text-lg transition-colors"
    :class="
      variant === 'black'
        ? '!bg-neutral-950 hover:!bg-neutral-800'
        : '!bg-cardinal hover:!bg-cardinal-500'
    "
  >
    <i v-if="icon" class="mr-2" :class="[icon]"></i>
    <slot />
  </UButton>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    variant?: 'primary' | 'black';
    icon?: string;
  }>(),
  {
    variant: 'primary',
  }
);
</script>
